import { Layout } from './layout';

Layout.displayName = 'Subheadline';

export { Layout as Subheadline };

export type { Props as SubheadlineProps } from './types';
